import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NEET_PHYSICS_CH1_QUESTIONS } from "../data/neetPhysicsCh1Questions";
import { NEET_PHYSICS_CH2_QUESTIONS } from "../data/neetPhysicsCh2Questions";
import { NEET_PHYSICS_CH3_QUESTIONS } from "../data/neetPhysicsCh3Questions";
import { NEET_PHYSICS_CH4_QUESTIONS } from "../data/neetPhysicsCh4Questions";
import { NEET_PHYSICS_CH5_QUESTIONS } from "../data/neetPhysicsCh5Questions";
import { NEET_PHYSICS_CH6_QUESTIONS } from "../data/neetPhysicsCh6Questions";
import { NEET_PHYSICS_CH7_QUESTIONS } from "../data/neetPhysicsCh7Questions";
import { NEET_PHYSICS_CH8_QUESTIONS } from "../data/neetPhysicsCh8Questions";
import { NEET_PHYSICS_CH9_QUESTIONS } from "../data/neetPhysicsCh9Questions";
import { NEET_PHYSICS_CH10_QUESTIONS } from "../data/neetPhysicsCh10Questions";
import { NEET_PHYSICS_CH11_QUESTIONS } from "../data/neetPhysicsCh11Questions";
import { NEET_PHYSICS_CH12_QUESTIONS } from "../data/neetPhysicsCh12Questions";
import { NEET_PHYSICS_CH13_QUESTIONS } from "../data/neetPhysicsCh13Questions";
import { NEET_PHYSICS_CH14_QUESTIONS } from "../data/neetPhysicsCh14Questions";
import { NEET_PHYSICS_CH15_QUESTIONS } from "../data/neetPhysicsCh15Questions";
import { NEET_PHYSICS_CH16_QUESTIONS } from "../data/neetPhysicsCh16Questions";
import { NEET_PHYSICS_CH17_QUESTIONS } from "../data/neetPhysicsCh17Questions";
import { NEET_PHYSICS_CH18_QUESTIONS } from "../data/neetPhysicsCh18Questions";
import { NEET_PHYSICS_CH19_QUESTIONS } from "../data/neetPhysicsCh19Questions";
import { NEET_PHYSICS_CH20_QUESTIONS } from "../data/neetPhysicsCh20Questions";
import { NEET_PHYSICS_CH21_QUESTIONS } from "../data/neetPhysicsCh21Questions";
import { NEET_PHYSICS_CH22_QUESTIONS } from "../data/neetPhysicsCh22Questions";
import { NEET_PHYSICS_CH23_QUESTIONS } from "../data/neetPhysicsCh23Questions";
import { NEET_PHYSICS_CH24_QUESTIONS } from "../data/neetPhysicsCh24Questions";
import { NEET_PHYSICS_CH25_QUESTIONS } from "../data/neetPhysicsCh25Questions";
import { NEET_PHYSICS_CH26_QUESTIONS } from "../data/neetPhysicsCh26Questions";
import { NEET_PHYSICS_CH27_QUESTIONS } from "../data/neetPhysicsCh27Questions";
import { NEET_PHYSICS_CH28_QUESTIONS } from "../data/neetPhysicsCh28Questions";
import { NEET_PHYSICS_CH29_QUESTIONS } from "../data/neetPhysicsCh29Questions";

// ── Daily quote — shown on click, bilingual (English + Tamil) ─────────────────
// Add more entries here later to rotate one-per-day (day-of-year % QUOTES.length).
const QUOTES = [
  {
    en: "Only education, self-respect and rational qualities will uplift the down-trodden.",
    ta: "கல்வி, சுயமரியாதை மற்றும் பகுத்தறிவு மட்டுமே அடிமைப்படுத்தப்பட்டவர்களை உயர்த்தும்.",
  },
];
function getTodaysQuote() {
  const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
  return QUOTES[dayOfYear % QUOTES.length];
}

// ── NEET Physics — chapter menu / hub page ──────────────────────────────────
// Chapter list follows the NCERT Class 11 & 12 Physics textbooks (the basis
// for the NEET syllabus). All 29 chapters (Class 11 + Class 12) are now built.
const CLASS11_CHAPTERS = [
  { n: 1,  title: "Units and Measurements",                 to: "/neet-physics-ch1",  questions: NEET_PHYSICS_CH1_QUESTIONS.length },
  { n: 2,  title: "Motion in a Straight Line",               to: "/neet-physics-ch2",  questions: NEET_PHYSICS_CH2_QUESTIONS.length },
  { n: 3,  title: "Motion in a Plane",                       to: "/neet-physics-ch3",  questions: NEET_PHYSICS_CH3_QUESTIONS.length },
  { n: 4,  title: "Newton's Laws of Motion",                 to: "/neet-physics-ch4",  questions: NEET_PHYSICS_CH4_QUESTIONS.length },
  { n: 5,  title: "Work, Energy and Power",                  to: "/neet-physics-ch5",  questions: NEET_PHYSICS_CH5_QUESTIONS.length },
  { n: 6,  title: "Centre of Mass and System of Particles",  to: "/neet-physics-ch6",  questions: NEET_PHYSICS_CH6_QUESTIONS.length },
  { n: 7,  title: "Rotational Motion",                       to: "/neet-physics-ch7",  questions: NEET_PHYSICS_CH7_QUESTIONS.length },
  { n: 8,  title: "Gravitation",                             to: "/neet-physics-ch8",  questions: NEET_PHYSICS_CH8_QUESTIONS.length },
  { n: 9,  title: "Mechanical Properties of Solids",         to: "/neet-physics-ch9",  questions: NEET_PHYSICS_CH9_QUESTIONS.length },
  { n: 10, title: "Mechanical Properties of Fluids",         to: "/neet-physics-ch10", questions: NEET_PHYSICS_CH10_QUESTIONS.length },
  { n: 11, title: "Thermal Properties of Matter",            to: "/neet-physics-ch11", questions: NEET_PHYSICS_CH11_QUESTIONS.length },
  { n: 12, title: "Thermodynamics",                          to: "/neet-physics-ch12", questions: NEET_PHYSICS_CH12_QUESTIONS.length },
  { n: 13, title: "Kinetic Theory of Gases",                 to: "/neet-physics-ch13", questions: NEET_PHYSICS_CH13_QUESTIONS.length },
  { n: 14, title: "Oscillations",                            to: "/neet-physics-ch14", questions: NEET_PHYSICS_CH14_QUESTIONS.length },
  { n: 15, title: "Waves",                                   to: "/neet-physics-ch15", questions: NEET_PHYSICS_CH15_QUESTIONS.length },
];

const CLASS12_CHAPTERS = [
  { n: 16, title: "Electric Charges and Fields",                to: "/neet-physics-ch16", questions: NEET_PHYSICS_CH16_QUESTIONS.length },
  { n: 17, title: "Electrostatic Potential and Capacitance",    to: "/neet-physics-ch17", questions: NEET_PHYSICS_CH17_QUESTIONS.length },
  { n: 18, title: "Current Electricity",                        to: "/neet-physics-ch18", questions: NEET_PHYSICS_CH18_QUESTIONS.length },
  { n: 19, title: "Moving Charges and Magnetism",                to: "/neet-physics-ch19", questions: NEET_PHYSICS_CH19_QUESTIONS.length },
  { n: 20, title: "Magnetism and Matter",                        to: "/neet-physics-ch20", questions: NEET_PHYSICS_CH20_QUESTIONS.length },
  { n: 21, title: "Electromagnetic Induction",                   to: "/neet-physics-ch21", questions: NEET_PHYSICS_CH21_QUESTIONS.length },
  { n: 22, title: "Alternating Current",                         to: "/neet-physics-ch22", questions: NEET_PHYSICS_CH22_QUESTIONS.length },
  { n: 23, title: "Electromagnetic Waves",                       to: "/neet-physics-ch23", questions: NEET_PHYSICS_CH23_QUESTIONS.length },
  { n: 24, title: "Ray Optics and Optical Instruments",          to: "/neet-physics-ch24", questions: NEET_PHYSICS_CH24_QUESTIONS.length },
  { n: 25, title: "Wave Optics",                                 to: "/neet-physics-ch25", questions: NEET_PHYSICS_CH25_QUESTIONS.length },
  { n: 26, title: "Dual Nature of Radiation and Matter",         to: "/neet-physics-ch26", questions: NEET_PHYSICS_CH26_QUESTIONS.length },
  { n: 27, title: "Atoms",                                       to: "/neet-physics-ch27", questions: NEET_PHYSICS_CH27_QUESTIONS.length },
  { n: 28, title: "Nuclei",                                      to: "/neet-physics-ch28", questions: NEET_PHYSICS_CH28_QUESTIONS.length },
  { n: 29, title: "Semiconductor Electronics",                   to: "/neet-physics-ch29", questions: NEET_PHYSICS_CH29_QUESTIONS.length },
];

const S = {
  page: { minHeight:"100vh", background:"linear-gradient(135deg,#0f172a,#1a1a2e)", fontFamily:"'Segoe UI',sans-serif", color:"#e2e8f0", padding:"18px 16px 80px" },
  back: { color:"#94a3b8", fontSize:13, textDecoration:"none" },
  sectionHead: { fontSize:13, fontWeight:800, color:"#fbbf24", textTransform:"uppercase", letterSpacing:0.6, margin:"22px 4px 10px" },
  card: { display:"block", textDecoration:"none", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(37,99,235,0.4)", borderRadius:14, padding:"14px 16px", marginBottom:10 },
  cardSoon: { background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"14px 16px", marginBottom:10, opacity:0.55 },
};

function ChapterCard({ ch }) {
  if (ch.to) {
    return (
      <Link to={ch.to} style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <span style={{ fontSize:11, color:"#60a5fa", fontWeight:700 }}>CHAPTER {ch.n}</span>
            <div style={{ fontWeight:700, fontSize:14.5, color:"#fff", marginTop:2 }}>{ch.title}</div>
          </div>
          <span style={{ background:"#2563eb", color:"#fff", borderRadius:20, padding:"3px 12px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>
            {ch.questions} questions
          </span>
        </div>
      </Link>
    );
  }
  return (
    <div style={S.cardSoon}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          <span style={{ fontSize:11, color:"#64748b", fontWeight:700 }}>CHAPTER {ch.n}</span>
          <div style={{ fontWeight:600, fontSize:14.5, color:"#94a3b8", marginTop:2 }}>{ch.title}</div>
        </div>
        <span style={{ background:"rgba(255,255,255,0.08)", color:"#94a3b8", borderRadius:20, padding:"3px 12px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>
          Coming soon
        </span>
      </div>
    </div>
  );
}

export default function NeetPhysicsMenuPage() {
  const [showQuote, setShowQuote] = useState(false);
  const quote = getTodaysQuote();

  return (
    <div style={S.page}>
      <Link to="/" style={S.back}>← Back to Home</Link>

      <div style={{ textAlign:"center", padding:"14px 0 22px" }}>
        <div style={{ fontSize:28, fontWeight:800, color:"#fff" }}>🧪 NEET Physics</div>
        <div style={{ fontSize:14, fontWeight:600, color:"#fbbf24", marginTop:4 }}>Chapter-wise concept guides &amp; practice questions</div>
        <div style={{ fontSize:12.5, color:"#94a3b8", marginTop:6, maxWidth:480, marginLeft:"auto", marginRight:"auto" }}>
          Chapters follow the NCERT Class 11 &amp; 12 Physics textbooks that the NEET syllabus is based on. All 29 chapters — the complete Class 11 &amp; 12 Physics syllabus — are ready.
        </div>

        <button
          onClick={() => setShowQuote(v => !v)}
          style={{ marginTop:14, background:"rgba(251,191,36,0.12)", border:"1px solid rgba(251,191,36,0.35)", color:"#fbbf24", borderRadius:20, padding:"6px 16px", fontSize:12.5, fontWeight:700, cursor:"pointer" }}
        >
          📜 {showQuote ? "Hide" : ""} Daily Quote
        </button>

        {showQuote && (
          <div style={{ maxWidth:520, margin:"14px auto 0", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(251,191,36,0.25)", borderRadius:14, padding:"16px 20px", textAlign:"left" }}>
            <div style={{ fontSize:13.5, color:"#f1f5f9", lineHeight:1.7, fontStyle:"italic" }}>&ldquo;{quote.en}&rdquo;</div>
            <div style={{ fontSize:13.5, color:"#cbd5e1", lineHeight:1.8, marginTop:10 }}>&ldquo;{quote.ta}&rdquo;</div>
          </div>
        )}
      </div>

      <div style={S.sectionHead}>Class 11</div>
      {CLASS11_CHAPTERS.map(ch => <ChapterCard key={ch.n} ch={ch} />)}

      <div style={S.sectionHead}>Class 12</div>
      {CLASS12_CHAPTERS.map(ch => <ChapterCard key={ch.n} ch={ch} />)}

      <div style={{ textAlign:"center", fontSize:11.5, color:"#64748b", marginTop:20 }}>
        Content is drafted for exam practice and NOT YET human-reviewed — verify against NCERT and the official NEET syllabus before relying on it.
      </div>
    </div>
  );
}
